export const environment = {
  production: false,
  stage: 'prod',
  apiUrl: 'https://api.hubcharge.pro'
};
